import { Link } from 'react-router-dom'
import siteContent from '../content/siteContent'
import './Footer.css'

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-brand">
            <h3>{siteContent.footer.brandName}</h3>
            <p>{siteContent.footer.tagline}</p>
          </div>
          <div className="footer-links">
            <Link to="/privacy-policy">{siteContent.footer.privacyLink}</Link>
          </div>
        </div>
        <div className="footer-copyright">
          {siteContent.footer.copyright}
        </div>
      </div>
    </footer>
  )
}